class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this._closeTimer = null;
    this.onPointerEnter = this.openOnHover.bind(this);
    this.onPointerLeave = this.scheduleClose.bind(this);
    this.onViewportChange = this.updatePanelViewport.bind(this);
    this.addEventListener('pointerenter', this.onPointerEnter);
    this.addEventListener('pointerleave', this.onPointerLeave);
    window.addEventListener('resize', this.onViewportChange);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerenter', this.onPointerEnter);
    this.removeEventListener('pointerleave', this.onPointerLeave);
    window.removeEventListener('resize', this.onViewportChange);
    clearTimeout(this._closeTimer);
  }

  // Override close() to always cancel the pending timer so that external
  // callers (e.g. StickyHeader.closeMenuDisclosure) don't leave a stale timer
  // running that would fire after the menu has already been closed externally.
  close() {
    clearTimeout(this._closeTimer);
    this._closeTimer = null;
    super.close();
  }

  openOnHover() {
    if (!this.desktopHover.matches) return;

    // Cancel any pending close for this element.
    clearTimeout(this._closeTimer);
    this._closeTimer = null;

    // Close any sibling menus immediately.
    this.closest('.header__inline-menu')
      ?.querySelectorAll('header-menu')
      .forEach((menu) => {
        if (menu !== this) menu.close();
      });

    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  scheduleClose() {
    if (!this.desktopHover.matches) return;
    if (this.contains(document.activeElement)) return;

    clearTimeout(this._closeTimer);
    this._closeTimer = setTimeout(() => {
      this._closeTimer = null;
      if (!this.contains(document.activeElement)) this.close();
    }, 300);
  }

  onToggle() {
    const botanical = this.querySelector('.whatahoot-botanical-inline');
    if (botanical) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      botanical.classList.toggle('is-animation-ready', !reduceMotion);
      botanical.classList.toggle('is-visible', this.mainDetailsToggle.open && !reduceMotion);
    }

    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu details[open]'));

    if (this.mainDetailsToggle.open) this.updatePanelViewport();
  }

  updatePanelViewport() {
    if (!this.header || !window.matchMedia('(min-width: 990px)').matches || !this.mainDetailsToggle.open) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
